import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetProtipManifestQuery } from "../../api/utility.api.slice";
import { getLatestApiSelector, marketName } from "../../utils/helpers";

// notes share the protips manifest; the prefix keeps a note from colliding
// with a proTip published under the same field key
export const getNoteKey = (fieldKey) => `note-${fieldKey}`;

export const useProtipKeys = () => {
  const { applicationType, recordType } = useParams();
  const formConfigMutation = useSelector((state) =>
    getLatestApiSelector(state, "getFormConfig")
  );

  const _processDefKey = applicationType || recordType || `${marketName}-misc`;
  let _taskDefinitionKey = "default";
  if (applicationType) _taskDefinitionKey = "start";
  if (applicationType && formConfigMutation?.data?.name === "record")
    _taskDefinitionKey = "record";
  if (recordType) _taskDefinitionKey = "record";

  return {
    processDefKey: _processDefKey,
    taskDefinitionKey: _taskDefinitionKey,
  };
};

const useProtipManifest = () => {
  const keys = useProtipKeys();
  const { data, isLoading, error } = useGetProtipManifestQuery(keys, {
    skip: !keys.processDefKey || !keys.taskDefinitionKey,
  });
  return { ...keys, manifest: data, isLoading, error };
};

export default useProtipManifest;
